import * as React from "react";
import * as moment from "moment";
import * as _ from "lodash";
import * as ReactGA from "react-ga";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import InputRange from "react-input-range";
import Button from "reactstrap/lib/Button";
import { Form } from "../../../share/components/Form/Form";
import CaseSugester from "../../Alert/Create/components/CaseSugester";
import { SearchBar, IOnSelectChange } from "src/modules/Alert/Create/components/SearchBar";
import DateRange from "src/share/components/DateRange/DateRange";
import SidebarContainer from "src/modules/Routing/Sidebar/SidebarContainer";
import ChildSelector from "./components/ChildSelector";
import Map from "src/share/components/Maps/Map/Map";
import { Loader } from "src/modules/Alert/Create/components/Loader";
import { IReduxState } from "src/reduxTypes";
import { IGeoSearchState, IGeoSearchProps, initialGeoSearchState, ISearchRequest } from "src/share/types/geoSearch";
import { CountryRegionData } from "src/packages/country-selector/data";
import { GeoSearchService } from "src/share/services/geoSearch";
import { momentToMiliseconds, timestampToMoment } from "src/share/utils/utils";
import GFCaseInformation from "./components/GFCaseInformation";
import routes from "src/modules/Routing/routes";
import "./GeoSearchForm.css";
import { CasesService } from "src/share/services/cases";
import { RoutesModules } from "src/modules/Routing/types";

export class GeoSearchForm extends React.Component<IGeoSearchProps, IGeoSearchState> {
  public constructor(props: IGeoSearchProps) {
    super(props);
    this.state = _.cloneDeep(initialGeoSearchState);
  }
  public componentDidMount() {
    const newState = this.props.history.location.state as any
    if (newState && newState.caseInfo && newState.caseInfo.caseId) {
      this.setHistoryState(newState)
    }
  }
  private async setHistoryState(newState) {
    this.setState({ loading: true });
    const { caseId } = newState.caseInfo
    const caseInfo = await CasesService.getCaseByID(caseId)
    this.setState({
      ...newState,
      children: caseInfo.children.map((child) => ({ ...child, name: child.fullName, id: child.childId })),
      caseInfo: { ...caseInfo, caseId },
      dateRange: {
        startDate: timestampToMoment(newState.dateRange.startDate),
        endDate: timestampToMoment(newState.dateRange.endDate)
      },
      isCaseSelected: true,
      isLocationSelected: true
    })
    this.props.history.replace(routes.GEOSEARCH_FORM, {})
  }
  private save = async () => {
    try {
      this.logGA();
      this.setState({ loading: true })
      const search: ISearchRequest = {
        caseId: this.state.caseInfo.caseId,
        radius: this.state.radius,
        center: this.state.selectedLocation,
        dateRange: { gte: momentToMiliseconds(this.state.dateRange.startDate), lte: momentToMiliseconds(this.state.dateRange.endDate) },
        personId: this.state.selectedChild,
        personType: "child"
      };
      const searchId = await GeoSearchService.search(search);
      this.props.history.push(`${routes.GEOSEARCH_RESULT.replace(":searchId", searchId)}`);
    } catch (error) {
      toastr.error("Error", error.payload);
      this.setState({ loading: false });
    }
  };
  private logGA() {
    ReactGA.event({
      category: "GeoSearch",
      action: "Perform a Geo Search",
      label: "Searches management"
    });
  }
  private validSubmit = () => {
    if (!this.state.caseInfo.caseId) {
      toastr.error("The Case Id is required", "Please search and select the Case Id");
      return;
    }
    if (!this.state.selectedChild) {
      toastr.error("The child information is required", "Please select a child with which perform the search.");
      return;
    }
    if (!this.state.dateRange.startDate || !this.state.dateRange.endDate) {
      toastr.error("The date range is required", "Please select the starting date.");
      return;
    }
    if (!this.state.isLocationSelected) {
      toastr.error("The geo location is required", "Please select a specific location with which perform the search.");
      return;
    }
    this.save();
  };
  private invalidSubmit = () => {
    toastr.error("There are some required values", "Please fill all the required values");
  };
  private getAgencyCountry = () => {
    if (this.state.caseInfo.agencyCode === "ALL") {
      return null;
    }
    return { countryCode: this.getCountryCodeByName(this.state.caseInfo.country), code: this.props.auth.agencyCode };
  };
  private getCountryCodeByName(name) {
    const country = CountryRegionData.find((c) => c.countryName === name);
    return country ? country.countryShortCode : "";
  }
  private handleChangeCaseId = (caseId: string) => {
    this.setState((state) => ({ caseInfo: { ...state.caseInfo, caseId } }));
  };
  private handleCaseSelected = (selectedCase) => {
    const children = selectedCase.children.map((child) => ({ id: child.childId, name: child.fullName, images: child.images }));
    this.setState({ caseInfo: selectedCase, children, isCaseSelected: true, selectedChild: children[0].id });
  };
  private handleChildSelected = (childId: string) => {
    this.setState({ selectedChild: childId });
  };
  private handleDatesChange = (date) => {
    this.setState((state) => ({
      dateRange: { ...state.dateRange, ...date, endDate: moment(date.startDate).add(1, "days") }
    }));
  };
  private handleDateFocusChange = ({ focus }) => {
    if (focus === "startDate") {
      return this.setState((state) => ({ dateRange: { ...state.dateRange, endDate: null, focus } }));
    }
    return this.setState((state) => {
      const startDate = state.dateRange.startDate;
      return { dateRange: { ...state.dateRange, endDate: startDate ? moment(startDate).add(1, "days") : null, focus } };
    });
  };
  private handleMapChange = (center) => {
    this.setState({ selectedLocation: center });
  };
  private onSelectSearchBar = (selectChange: IOnSelectChange) => {
    this.setState({ selectedLocation: selectChange.center as any, isLocationSelected: !!selectChange.countryCode });
  };
  private handleAddresChange = (address) => {
    this.setState({ location: address });
  };
  private handleClearData = () => {
    const initial = _.cloneDeep(initialGeoSearchState);
    this.setState({ ...initial });
  };
  private getAgencyName = () => {
    const { auth } = this.props;
    const currentAgency = auth && auth.agencies && auth.agencies.find((agency) => agency.code === this.state.caseInfo.agencyCode);
    return currentAgency && currentAgency.name;
  };
  private getLocation = () => {
    const { country, state, city } = this.state.caseInfo;
    return `${city ? `${city}, ` : ""}${state ? `${state}, ` : ""}${country && `${country}.`}`
  };
  private formatMiles = (value: number) => `${Math.round(value * 10) / 10} miles`;
  public render() {
    const agency = this.getAgencyCountry();
    const children = this.state.children;
    return (
      <div className="geosearch-content">
        <div className="geosearch-container white-background">
          <h1>PDTR Image Search</h1>
          <Form onValidSubmit={this.validSubmit} onInvalidSubmit={this.invalidSubmit}>
            <div className="geosearch-form">
              <div className="geosearch-form__radius-range">
                <InputRange
                  maxValue={7}
                  minValue={1}
                  allowSameValues={true}
                  disabled={this.state.loading}
                  value={this.state.radius}
                  formatLabel={this.formatMiles}
                  onChange={(value: number) => this.setState({ radius: +value.toFixed(2) })}
                  step={0.1}
                />
              </div>
              <div className="geosearch-form__map">
                <SearchBar
                  address={this.state.location}
                  agency={agency}
                  agencyCode={this.props.auth.agencyCode}
                  onSelect={this.onSelectSearchBar}
                  onChange={this.handleAddresChange}
                  disabled={!this.state.isCaseSelected || this.state.loading}
                />
                <Map
                  radius={this.state.radius}
                  center={this.state.selectedLocation || this.state.defaultLocation}
                  onMapChange={this.handleMapChange}
                  isLocationSelected={this.state.isLocationSelected}
                  isMapDisabled={!this.state.isLocationSelected}
                />
              </div>
              <div className="geosearch-form__inputs">
                <div className="geosearch-form__case-input">
                  <h5>Case ID:</h5>
                  <CaseSugester
                    onChange={this.handleChangeCaseId}
                    caseId={this.state.caseInfo.caseId || ""}
                    isEdit={this.state.loading}
                    auth={this.props.auth}
                    onSelect={this.handleCaseSelected}
                  />
                </div>
                <GFCaseInformation
                  location={this.getLocation()}
                  agency={this.getAgencyName()}
                  openDate={this.state.caseInfo.openDate}
                  circumstances={this.state.caseInfo.circumstances}
                />
                <div className="geosearch-form__date-input">
                  <h5>Date Filter:</h5>
                  <DateRange
                    onDatesChange={this.handleDatesChange}
                    onFocusChange={this.handleDateFocusChange}
                    focusedInput={this.state.dateRange.focus}
                    numberOfMonths={1}
                    disabled={this.state.loading ? true : "endDate"}
                    startDate={this.state.dateRange.startDate}
                    endDate={this.state.dateRange.endDate}
                  />
                </div>
                <div className="geosearch-form__children-input">
                  <h5>Children:</h5>
                  {children.length > 0 &&
                    children.map((child) => (
                      <ChildSelector
                        key={child.id}
                        child={child}
                        isChildSelected={child.id === this.state.selectedChild}
                        onChildSelected={this.handleChildSelected}
                      />
                    ))}
                </div>
              </div>
              <div className="geosearch-form__actions">
                {
                  this.state.loading ?
                    <Loader loading={this.state.loading} /> :
                    <>
                      <Button type="submit" id="submitBTN" disabled={this.state.loading} className="btn btn-outline btn-green-fill float-right">
                        Submit
                      </Button>
                      <Button id="clearBTN" disabled={this.state.loading} onClick={this.handleClearData} className="btn btn-outline btn-grey-fill float-right">
                        Clear all
                      </Button>
                    </>
                }


              </div>
            </div>

          </Form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: IReduxState) => ({
  auth: state.auth
});

export default SidebarContainer(RoutesModules.GEOSEARCH)(connect(mapStateToProps)(GeoSearchForm));



// WEBPACK FOOTER //
// ./src/modules/GeoSearch/Search/GeoSearchForm.tsx